import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { formData } from '../../../../constants/actions'
import withColorSetting from '../../../../hoc/withColorSettings'
import {
  getCountry,
  getCurrentRegistration,
  getFormAddOnProducts,
  getFormId,
  getFormProducts,
  getFormSettings,
  getHierarchyCountryCode,
  getMemberTypes,
  getOrgTimezones,
  getQuestions,
  getUserId,
} from '../../../../selectors'
import QuestionsComponent from './component'

const mapStateToProps = state => ({
  currentRegistration: getCurrentRegistration(state),
  memberTypes: getMemberTypes(state),
  formProducts: getFormProducts(state),
  formAddOnProducts: getFormAddOnProducts(state),
  formTeamProducts: get(state, 'formInfo.team.products'),
  formSubEventProducts: get(state, 'formInfo.subEvents', []).flatMap(se => se?.products || []),
  questions: getQuestions(state),
  userId: getUserId(state),
  form: getFormId(state),
  defaultCountry: getCountry(state),
  hierarchyCountryCode: getHierarchyCountryCode(state),
  timezones: getOrgTimezones(state),
  formSettings: getFormSettings(state),
})

export default withRouter(
  connect(mapStateToProps, {
    setValue: formData.setValues,
    setTeam: formData.setTeamValues,
  })(withColorSetting(QuestionsComponent))
)
